{
  "ui": {
    "feedback": "Comentaris",
    "credits": "Crèdits",
    "currentMaintainer": "Manteniment actual",
    "maintainerPeriod": "Des de 2026",
    "originalTeam": "Equip original",
    "creditsCampaigns": "Jungla i Nadal",
    "moreSettings": "Més opcions",
    "chooseLanguage": "Tria la teva llengua",
    "notebookTools": "Eines del quadern",
    "visualGuide": "Guia amb imatges",
    "templeSoon": "Properament",
    "playAdventure": "Juga",
    "story": "La història",
    "loadingAdventure": "Preparem l’aventura…",
    "storyOpening": "Una excursió escolar a la selva. En Marco i la Sophia exploren amb els amics. Un ocell de colors crida l’atenció d’en Marco i ell el segueix entre els arbres. De sobte està sol. Ajuda els exploradors a trobar el camí!",
    "storyEnding": "En Marco i la Sophia arriben junts al temple perdut. Un rostre misteriós en vigila l’entrada. Els espera una nova aventura!",
    "blockCategories": "Pestanyes del quadern",
    "actions": "Accions",
    "loops": "Bucles",
    "conditions": "Condicions",
    "title": "Run Marco! — Una aventura al teu quadern",
    "home": "Inici de Run Marco",
    "map": "Mapa de l’aventura",
    "worlds": "Tria una aventura",
    "notebook": "El meu quadern",
    "notebookToggle": "Obre o tanca el quadern",
    "notebookOpen": "Obre el quadern",
    "notebookClose": "Mira el camí",
    "page": "Pàgina {number}",
    "level": "Ruta {number}",
    "run": "Som-hi!",
    "stop": "Atura",
    "step": "Un pas",
    "stepTitle": "Executa una instrucció",
    "reset": "Torna a l’inici",
    "add": "Afegeix",
    "addLabel": "Tria un bloc per afegir",
    "addHint": "Uneix els blocs i prem Juga.",
    "undo": "Desfés",
    "clear": "Pàgina nova",
    "hint": "Una petita pista",
    "help": "Com es juga",
    "settings": "Opcions",
    "language": "Llengua del joc",
    "blockLanguage": "Llengua dels blocs",
    "blockLanguageNote": "Pots triar una altra llengua per als blocs.",
    "musicOn": "Activa el so",
    "musicOff": "Desactiva el so",
    "sound": "Música i efectes de so",
    "speed": "Velocitat de l’aventura",
    "chooseExplorer": "Tria el teu explorador",
    "explorer": "Explorador",
    "marco": "Marco",
    "sophia": "Sophia",
    "close": "Tanca",
    "done": "A explorar!",
    "loading": "Busquem el camí…",
    "loadError": "No s’ha pogut carregar l’aventura. Torna a carregar la pàgina per provar-ho de nou.",
    "imageError": "No s’han pogut carregar algunes imatges. Torna a carregar la pàgina.",
    "gemGoal": "Troba la gemma",
    "goal": "Troba l’estrella daurada",
    "cover": "Il·lumina cada casella una sola vegada",
    "lit": "{count} / {total} caselles il·luminades",
    "explored": "{count} / {total} rutes explorades",
    "facing": "Mirant cap a {direction} {arrow}",
    "boardLabel": "{name} a {level}, mirant cap a {direction}. {steps}. {objective}.",
    "up": "amunt",
    "down": "avall",
    "left": "l’esquerra",
    "right": "la dreta",
    "steps_one": "{count} pas",
    "steps_other": "{count} passos",
    "blocks_one": "{count} bloc",
    "blocks_other": "{count} blocs",
    "stars_one": "{count} estrella",
    "stars_other": "{count} estrelles",
    "place": "Afegeix blocs",
    "atEnd": "Al final",
    "insideRepeat": "Dins de repeteix {number}",
    "insideIf": "Dins de si {number}",
    "insideElse": "Dins de si no {number}",
    "readyFirst": "Un petit pas. Afegeix un bloc per avançar i som-hi!",
    "ready": "On anem? Prepara un pla al quadern.",
    "back": "Tornem a l’inici. Els blocs estan a punt per provar-ho de nou.",
    "empty": "Primer afegeix un bloc al quadern.",
    "win": "Has trobat el camí!",
    "winCover": "Has il·luminat el camí!",
    "winDetails": "{steps} · {blocks}",
    "brilliant": "Quina aventura!",
    "simpler": "Pots fer-ho amb menys blocs?",
    "complete": "Ruta completada! Les teves millors estrelles s’han desat.",
    "next": "Ruta següent",
    "allWorlds": "Més aventures",
    "replay": "Torna a jugar",
    "shortGoal": "Gairebé! Afegeix uns quants blocs per arribar a l’estrella.",
    "shortGem": "Gairebé! Afegeix uns quants blocs per arribar a la gemma.",
    "shortCover": "Algunes caselles encara són fosques. Com hi arribem?",
    "checking": "Observem el camí…",
    "paused": "Aturat. Juga torna a començar des de l’inici.",
    "going": "En marxa!",
    "stepped": "Un pas més a prop. Prem Un pas o Juga per continuar.",
    "clueCover": "Comença per una vora i recorre tota la figura. Un salt passa sobre una casella sense il·luminar-la.",
    "clueCondition": "Mira el camí del davant. Una condició ajuda l’explorador a triar què fer.",
    "clueRepeat": "Quins passos es repeteixen? Posa aquest patró dins d’un bloc de repetició.",
    "clueForward": "Avançar segueix la mirada de l’explorador. Compta les caselles fins a l’estrella.",
    "clueGem": "Avançar segueix la mirada de l’explorador. Compta les caselles fins a la gemma.",
    "clueTurn": "Girar canvia la direcció sense avançar. Segueix el camí amb el dit.",
    "mapNote": "Tria una ruta. Les teves millors estrelles es conserven.",
    "mapLevel": "Ruta {number}: {name}. {stars}.",
    "locked": "Completa la ruta anterior per desbloquejar aquesta.",
    "soundBlocked": "Toca el botó del so per escoltar l’aventura.",
    "clearTitle": "Passem a una pàgina nova?",
    "clearNote": "S’esborraran els blocs d’aquesta ruta. Desfés els pot recuperar.",
    "keep": "Conserva els meus blocs",
    "clearConfirm": "Esborra els blocs",
    "fresh": "Una pàgina nova. On ens portarà el teu pròxim pla?",
    "localProgress": "El progrés es desa en aquest dispositiu.",
    "helpBuild": "Prepara un pla",
    "helpBuildText": "Arrossega blocs al quadern i uneix-los, o toca un bloc per afegir-lo. Tria «Dins de repeteix» per afegir passos a un bucle.",
    "helpTurn": "Segueix el teu explorador",
    "helpTurnText": "Avançar segueix la seva mirada. Esquerra i dreta giren sense avançar. Un salt recorre dues caselles.",
    "helpTry": "Prova, observa i torna-hi",
    "helpTryText": "Prem Juga per provar el pla o Un pas per a una instrucció. La fletxa corba torna a l’inici i conserva els blocs.",
    "helpWorlds": "Cada aventura té un objectiu",
    "helpWorldsText": "A la Selva, troba la gemma. Per Nadal, il·lumina cada casella lliure una vegada. Al Temple i a l’Egeu, completa les reparacions i els objectius visibles i arriba a la sortida.",
    "noTrail": "Aquí no hi ha camí! Prova de girar abans d’avançar.",
    "broken": "Aquest pont està trencat. El pots saltar?",
    "blocked": "Alguna cosa barra el pas. Prova un salt o una altra ruta.",
    "alreadyLit": "Aquesta casella ja està il·luminada. Visita cada casella una sola vegada.",
    "loopError": "Aquest pla es repeteix sense parar. Prova de canviar el bucle.",
    "repeatError": "Tria un nombre de repeticions de l’1 al 99.",
    "unsupported": "Treu el bloc no compatible i torna-ho a provar.",
    "connect": "Uneix els blocs en una sola cadena i prem Juga.",
    "path": "camí",
    "steps_many": "{count} passos",
    "blocks_many": "{count} blocs",
    "stars_many": "{count} estrelles",
    "backpack": "Motxilla",
    "templeGems": "Gemmes del temple",
    "gemsCollected": "Gemmes: {count} / {total}",
    "gemsReady": "Has recollit totes les gemmes!",
    "aegeanTitle": "Els misteris de l’Egeu",
    "harbour": "Port",
    "aegeanDescription": "Explora el port: repara estacions, reutilitza rutines i envia un nombre amb cada encàrrec.",
    "templeBetaNote": "Beta · Estem revisant els reptes i les lliçons",
    "aegeanBetaNote": "Beta · Els primers 3 nivells del port",
    "seasonal": "Aventura de temporada",
    "choosePreview": "Tria un nivell de mostra",
    "repairs": "Reparacions",
    "reachExit": "Arriba a la sortida",
    "taskRequirements": "Objectius de la missió",
    "lessonGuided": "Pràctica guiada · completa el programa inclòs",
    "lessonRepair": "Depuració · corregeix el programa inclòs",
    "lessonChallenge": "Repte · crea el teu propi programa",
    "acc_define_parameter": "Rutina",
    "acc_call_argument": "Crida rutina",
    "acc_repeat_parameter": "Repeteix amb entrada",
    "parameter": "paràmetre",
    "argument": "envia",
    "callInput": "Entrada d’aquesta crida",
    "inputWaiting": "Executa el programa o avança pas a pas per veure l’entrada següent.",
    "argumentMismatch": "Una rutina amb paràmetre necessita una crida amb un nombre. Sense paràmetre, fes una crida normal.",
    "unsetParameter": "Fes servir el paràmetre només dins de la rutina que el rep. Els paràmetres estan separats de la memòria compartida.",
    "memoryObjective": "Revisa el registre de reparacions i els objectius de sortida. S’accepta qualsevol programa que els compleixi.",
    "gate": "El pas està bloquejat. Revisa les reparacions pendents.",
    "noPickup": "Situa’t sobre l’eina abans de recollir-la.",
    "creditLead": "Direcció d’equip i desenvolupament de programari",
    "creditArt": "Il·lustració i escenaris",
    "creditAnimation": "Animació",
    "creditUX": "Disseny d’interfície i experiència d’usuari",
    "creditDesign": "Disseny del joc",
    "creditStory": "Guió",
    "creditAudio": "Música i enginyeria de so",
    "lightLamp": "Encén el llum",
    "oilLamp": "Llum d’oli",
    "dustyStation": "estació amb pols",
    "betaLabel": "Beta",
    "noLamp": "Situa’t sobre un llum apagat abans d’encendre’l.",
    "collected": "Eina recollida · a punt per utilitzar",
    "dustyPrompt": "Situa’t sobre una estació amb pols abans d’utilitzar el pinzell.",
    "lampMissing": "Recull primer el llum d’oli. Mira a la motxilla.",
    "recursiveRoutine": "Aquesta rutina es crida a si mateixa. Utilitza una altra rutina; les crides recursives encara no estan disponibles."
  },
  "content": {
    "jungle.title": "Expedició a la selva",
    "jungle.description": "Segueix el camí fins al temple perdut.",
    "jungle-1": "Primers passos",
    "jungle-2": "Una mica més lluny",
    "jungle-3": "A la cantonada",
    "jungle-4": "Canvia de direcció",
    "jungle-5": "Segueix el camí",
    "jungle-6": "Una nova ruta",
    "jungle-7": "Nous camins",
    "jungle-8": "Cruïlla a la selva",
    "jungle-9": "Troba el camí",
    "jungle-10": "Pensa endavant",
    "jungle-11": "El camí llarg",
    "jungle-12": "Una ruta sinuosa",
    "jungle-13": "Un salt valent",
    "jungle-14": "Apareixen patrons",
    "jungle-15": "Repeteix el ritme",
    "jungle-16": "Tria un camí",
    "jungle-17": "Mira abans de saltar",
    "jungle-18": "Llegeix el camí",
    "jungle-19": "Una drecera enginyosa",
    "jungle-20": "Sota les capçades",
    "jungle-21": "Constructor de ponts",
    "jungle-22": "Més enllà del riu",
    "jungle-23": "Explora les ruïnes",
    "jungle-24": "Pedra i fusta",
    "jungle-25": "Un salt més gran",
    "jungle-26": "Segueix les pistes",
    "jungle-27": "Més amunt",
    "jungle-28": "Continua explorant",
    "jungle-29": "Camins recargolats",
    "jungle-30": "El jardí secret",
    "jungle-31": "Patrons amagats",
    "jungle-32": "Camins antics",
    "jungle-33": "Els últims girs",
    "jungle-34": "Cap al temple",
    "jungle-35": "Ja gairebé hi som",
    "jungle-36": "El temple perdut",
    "winter.title": "Camí d’hivern",
    "winter.description": "Deixa una llum a cada petjada.",
    "winter-1": "Passos a la neu",
    "winter-2": "Una altra direcció",
    "winter-3": "Cantonades gelades",
    "winter-4": "El camí més llarg",
    "winter-5": "Floc de neu",
    "winter-6": "Bucles d’hivern",
    "winter-7": "Explorador del gel",
    "winter-8": "Voltes i girs",
    "winter-9": "Lògica gelada",
    "winter-10": "Cercador de patrons",
    "winter-11": "Mestre del camí",
    "winter-12": "Meravella d’hivern",
    "temple.title": "El temple perdut",
    "temple.description": "Quaranta sales connectades: restaura un instrument celeste amb eines, memòria i rutines pròpies."
  },
  "blockly": {
    "ARIA_LABEL_TRASH_EMPTY": "Paperera buida",
    "OPEN_TRASH": "Obre la paperera",
    "BLOCK_LABEL_BEGIN_STACK": "Inici de la pila",
    "WORKSPACE_LABEL_1_STACK": "1 pila de blocs",
    "WORKSPACE_LABEL_MANY_STACKS": "%1 piles de blocs",
    "ARIA_TYPE_FIELD_NUMBER": "nombre",
    "ARIA_TYPE_FIELD_DROPDOWN": "llista desplegable",
    "ARIA_TYPE_FIELD_IMAGE": "imatge",
    "WORKSPACE_LABEL_PLAIN": "El meu quadern",
    "FIELD_LABEL_EDIT_PREFIX": "Edita %1",
    "BLOCK_LABEL_HAS_INPUT": "té una entrada",
    "BLOCK_LABEL_HAS_INPUTS": "té entrades",
    "BLOCK_LABEL_HAS_BRANCHES": "té %1 branques",
    "FIELD_LABEL_OPTION_INDEX": "Opció %1",
    "INPUT_LABEL_EMPTY": "Buit",
    "BLOCK_LABEL_DISABLED": "desactivat",
    "BLOCK_LABEL_COLLAPSED": "contret",
    "BLOCK_LABEL_BEGIN_PREFIX": "Inici: %1",
    "INPUT_LABEL_END_STATEMENT": "Final: %1",
    "ARIA_TYPE_FIELD_TEXT_INPUT": "text",
    "ARIA_TYPE_FIELD_INPUT": "entrada",
    "ARIA_TYPE_FIELD_TEXT_INPUT_ARGUMENT": "nom de l’entrada",
    "ARIA_TYPE_FIELD_TEXT_INPUT_PROCEDURE": "nom de la rutina"
  }
}
